import { render, staticRenderFns } from "./SimpleTextRow.vue?vue&type=template&id=2d77645a&scoped=true"
import script from "./SimpleTextRow.vue?vue&type=script&lang=js"
export * from "./SimpleTextRow.vue?vue&type=script&lang=js"
import style0 from "./SimpleTextRow.vue?vue&type=style&index=0&id=2d77645a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d77645a",
  null
  
)

export default component.exports